<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2022-02-08 09:38:40
 * @LastEditors: shenlin
 * @LastEditTime: 2022-07-28 13:34:48
-->
<template>
  <div class="mapCenter">
    <div id="mapContainer" class="map"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import 'echarts-gl'
import JSON from '/static/map/丽水市.json'
export default {
  name: 'Cockpit',
  props: {
    entList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  watch: {
    entList(val, old) {
      if (val.length) {
        const list = []
        val.forEach((ele) => {
          list.push({
            name: ele.entName,
            creditCode: ele.creditCode,
            value: [ele.lng, ele.lat, 5]
          })
        })
        if (list.length == 1) {
          list.push({
            name: '',
            creditCode: '',
            value: [0, 0, 5]
          })
        }
        this.option.series[0].data = val
        this.$nextTick(() => {
          this.echartObj.setOption(this.option, true)
        })
        // console.log(this.option.series[0].data)
      } else {
        this.option.series[0].data = []
        this.echartObj.setOption(this.option, true)
      }
    }
  },
  computed: {},
  components: {},
  data() {
    return {
      option: {
        tooltip: {
          position: 'top',
          textStyle: {
            color: '#fff' // 设置文字颜色
          },
          backgroundColor: '#2E7AEC', // 修改背景颜色
          borderColor: 'rgba(151, 151, 151, 1)', // 修改字体颜色
          trigger: 'item',
          formatter: function (params) {
            return params.name
          }
        },
        geo3D: {
          name: '丽水',
          type: 'map3D',
          map: '丽水',
          roam: true,
          boxDepth: 120, // 地图倾斜度
          boxHeight: 5,
          shading: 'lambert',
          regionHeight: 4, // 地图厚度
          label: {
            color: '#ffffff',
            fontSize: 16,
            // 标签的相关设置
            show: true, // (地图上的城市名称)是否显示标签 [ default: false ]
            formatter: function (params) {
              return params.name
            }
          },
          groundPlane: {
            show: false,
            color: '#aaa'
          },
          // symbol: 'image:///static/images/map.png',
          itemStyle: {
            // 三维地理坐标系组件 中三维图形的视觉属性，包括颜色，透明度，描边等。
            // areaColor: 'rgba(95,158,160,0.5)', // 地图板块的颜色
            color: '#0A7CF1', // 地图板块的颜色
            borderWidth: 1, // (地图板块间的分隔线)图形描边的宽度。加上描边后可以更清晰的区分每个区域 [ default: 0 ]
            borderColor: 'rgba(106, 235, 245, 1)' // 图形描边的颜色。[ default: #333 ]
          },
          emphasis: {
            itemStyle: {
              // 三维地理坐标系组件 中三维图形的视觉属性，包括颜色，透明度，描边等。
              // areaColor: 'rgba(95,158,160,0.5)', // 地图板块的颜色
              color: '#0A7CF1', // 地图板块的颜色
              borderWidth: 1, // (地图板块间的分隔线)图形描边的宽度。加上描边后可以更清晰的区分每个区域 [ default: 0 ]
              borderColor: 'rgba(106, 235, 245, 1)' // 图形描边的颜色。[ default: #333 ]
            }
          },
          light: {
            main: {
              intensity: 1,
              shadow: true,
              shadowQuality: 'ultra',
              alpha: 10,
              beta: 10
            },
            ambient: {
              color: '#fff',
              intensity: 0.6
            }
          },
          viewControl: {
            animation: false,
            // animationEasingUpdate: 10,
            minBeta: -360,
            maxBeta: 360,
            top: -20,
            zoomSensitivity: 1,
            distance: 160, // [ default: 100 ] 默认视角距离主体的距离，对于 geo3D 等其它组件来说是距离中心原点的距离
            alpha: 65, // 视角绕 x 轴，即上下旋转的角度。配合 beta 可以控制视角的方向。[ default: 40 ]
            beta: 15 // 视角绕 y 轴，即左右旋转的角度。[ default: 0 ]
          },
          data: [{ name: '丽水市' }]
        },
        series: [
          {
            name: '企业名称',
            type: 'scatter3D',
            coordinateSystem: 'geo3D',
            shading: 'lambert',
            itemStyle: {
              color: '#00FFFE'
            },
            geo3DIndex: 0,
            symbolSize: [24, 30],
            // symbol: 'pin',
            // symbol: 'path://static/images/nomal.svg',
            // symbol: function(params) {
            //   console.log(params)
            //   if (params[2] === '0') {
            //     return 'pin'
            //   } else {
            //     return 'diamond'
            //   }
            // },
            symbol:
              'path://M16.8461538,25.7777778 L16.6019328,26.093819 L16.6019328,26.093819 L15.9183629,26.9969908 L15.9183629,26.9969908 L15.5035605,27.5616454 L15.5035605,27.5616454 L15.1214868,28.096332 C15.0605353,28.1829491 15.0009474,28.2683175 14.9427232,28.3524373 L14.6097426,28.842172 C14.5042039,29.0004222 14.4041199,29.1536778 14.3094907,29.3019387 L14.0419675,29.7317375 C13.4140705,30.7687746 13.0930051,31.5248621 13.0787714,32 C13.0787714,31.5801937 12.8119364,30.9269612 12.2782663,30.0403025 L12.0332138,29.6460145 C11.9896489,29.5779179 11.9447226,29.5086304 11.8984349,29.4381519 L11.6043718,29.0009897 C11.5526385,28.9257475 11.4995437,28.8493143 11.4450876,28.7716901 L11.102014,28.2916537 C11.0421123,28.2092657 10.9808492,28.1256868 10.9182246,28.040917 L10.5261405,27.5180064 L10.5261405,27.5180064 L10.1013827,26.966513 L10.1013827,26.966513 L9.64395128,26.3864368 L9.64395128,26.3864368 L9.15384615,25.7777778 L16.8461538,25.7777778 Z M13,3.42307692 C18.842909,3.42307692 23.5769231,8.20969111 23.5769231,14.1111111 C23.5769231,20.0125311 18.842909,24.7991453 13,24.7991453 C7.15709096,24.7991453 2.42307692,20.0125311 2.42307692,14.1111111 C2.42307692,8.20969111 7.15709096,3.42307692 13,3.42307692 Z M13,4.57692308 C7.79721405,4.57692308 3.57692308,8.84410617 3.57692308,14.1111111 C3.57692308,19.3781161 7.79721405,23.6452991 13,23.6452991 C18.202786,23.6452991 22.4230769,19.3781161 22.4230769,14.1111111 C22.4230769,8.84410617 18.202786,4.57692308 13,4.57692308 Z M13.7692296,8.66666667 C13.9850066,8.66666667 14.1659101,8.82644674 14.203447,9.03554223 L14.2105911,9.11604895 L14.2105911,10.913583 L18.4035338,10.913583 C18.6193108,10.913583 18.8002143,11.0733631 18.8377512,11.2824585 L18.8448953,11.3629653 L18.8448929,17.879012 L19.1538462,17.879012 L19.1538462,18.7777778 L8.38461538,18.7777778 L8.38461538,17.879012 L8.69356868,17.879012 L8.69356868,9.11604895 C8.69356868,8.89635062 8.85049692,8.71215961 9.05586038,8.67394061 L9.13493018,8.66666667 L13.7692296,8.66666667 Z M12.3348029,15.2950645 L10.569352,15.2950645 L10.569352,16.1938303 L12.3348029,16.1938303 L12.3348029,15.2950645 Z M16.9691023,15.2950645 L15.2036514,15.2950645 L15.2036514,16.1938303 L16.9691023,16.1938303 L16.9691023,15.2950645 Z M12.3348029,13.4076575 L10.569352,13.4076575 L10.569352,14.3064232 L12.3348029,14.3064232 L12.3348029,13.4076575 Z M16.9691023,13.4076575 L15.2036514,13.4076575 L15.2036514,14.3064232 L16.9691023,14.3064232 L16.9691023,13.4076575 Z M12.3348029,11.5427248 L10.569352,11.5427248 L10.569352,12.4414906 L12.3348029,12.4414906 L12.3348029,11.5427248 Z',
            // 'path://M16.8461538,25.7777778 L16.6019328,26.093819 L16.6019328,26.093819 L15.9183629,26.9969908 L15.9183629,26.9969908 L15.5035605,27.5616454 L15.5035605,27.5616454 L15.1214868,28.096332 C15.0605353,28.1829491 15.0009474,28.2683175 14.9427232,28.3524373 L14.6097426,28.842172 C14.5042039,29.0004222 14.4041199,29.1536778 14.3094907,29.3019387 L14.0419675,29.7317375 C13.4140705,30.7687746 13.0930051,31.5248621 13.0787714,32 C13.0787714,31.5801937 12.8119364,30.9269612 12.2782663,30.0403025 L12.0332138,29.6460145 C11.9896489,29.5779179 11.9447226,29.5086304 11.8984349,29.4381519 L11.6043718,29.0009897 C11.5526385,28.9257475 11.4995437,28.8493143 11.4450876,28.7716901 L11.102014,28.2916537 C11.0421123,28.2092657 10.9808492,28.1256868 10.9182246,28.040917 L10.5261405,27.5180064 L10.5261405,27.5180064 L10.1013827,26.966513 L10.1013827,26.966513 L9.64395128,26.3864368 L9.64395128,26.3864368 L9.15384615,25.7777778 L16.8461538,25.7777778 Z M13,3.42307692 C18.842909,3.42307692 23.5769231,8.20969111 23.5769231,14.1111111 C23.5769231,20.0125311 18.842909,24.7991453 13,24.7991453 C7.15709096,24.7991453 2.42307692,20.0125311 2.42307692,14.1111111 C2.42307692,8.20969111 7.15709096,3.42307692 13,3.42307692 Z M13,4.57692308 C7.79721405,4.57692308 3.57692308,8.84410617 3.57692308,14.1111111 C3.57692308,19.3781161 7.79721405,23.6452991 13,23.6452991 C18.202786,23.6452991 22.4230769,19.3781161 22.4230769,14.1111111 C22.4230769,8.84410617 18.202786,4.57692308 13,4.57692308 Z M13.7692296,8.66666667 C13.9850066,8.66666667 14.1659101,8.82644674 14.203447,9.03554223 L14.2105911,9.11604895 L14.2105911,10.913583 L18.4035338,10.913583 C18.6193108,10.913583 18.8002143,11.0733631 18.8377512,11.2824585 L18.8448953,11.3629653 L18.8448929,17.879012 L19.1538462,17.879012 L19.1538462,18.7777778 L8.38461538,18.7777778 L8.38461538,17.879012 L8.69356868,17.879012 L8.69356868,9.11604895 C8.69356868,8.89635062 8.85049692,8.71215961 9.05586038,8.67394061 L9.13493018,8.66666667 L13.7692296,8.66666667 Z M12.3348029,15.2950645 L10.569352,15.2950645 L10.569352,16.1938303 L12.3348029,16.1938303 L12.3348029,15.2950645 Z M16.9691023,15.2950645 L15.2036514,15.2950645 L15.2036514,16.1938303 L16.9691023,16.1938303 L16.9691023,15.2950645 Z M12.3348029,13.4076575 L10.569352,13.4076575 L10.569352,14.3064232 L12.3348029,14.3064232 L12.3348029,13.4076575 Z M16.9691023,13.4076575 L15.2036514,13.4076575 L15.2036514,14.3064232 L16.9691023,14.3064232 L16.9691023,13.4076575 Z M12.3348029,11.5427248 L10.569352,11.5427248 L10.569352,12.4414906 L12.3348029,12.4414906 L12.3348029,11.5427248 Z',
            zlevel: 9999,
            label: {
              normal: {
                show: false,
                textStyle: {
                  color: '#ffffff',
                  fontSize: 12
                },
                position: 'top'
              },
              emphasis: {
                show: false,
                color: '#fff',
                fontSize: 14,
                fontWeight: 600,
                borderColor: 'rgba(151, 151, 151, 1)',
                borderWidth: 2,
                formatter(value) {
                  return value.data.name
                }
              }
            },
            // large: true,
            // largeThreshold: 2000,
            data: []
          }
        ]
      }
    }
  },
  created() {
    // 监听浏览器大小变化重渲染组件
    window.addEventListener('resize', () => {
      if (this.echartObj && this.echartObj.resize) {
        this.echartObj.resize()
      }
    })
  },
  mounted() {
    this.$nextTick(() => {
      this.initEchartMap()
    })
  },
  methods: {
    initEchartMap() {
      const _that = this
      // 初始化并渲染
      this.echartObj = echarts.init(document.getElementById('mapContainer'))
      echarts.registerMap('丽水', JSON)
      this.echartObj.setOption(_that.option, true)
      this.echartObj.on('click', function (args) {
        console.log(args)
        _that.$emit('mapGetEnt', {
          entName: args.data.name,
          creditCode: args.data.creditCode
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.mapCenter {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 78;
  #mapContainer {
    background: url('~@/assets/images/mapChassis.png') no-repeat;
    background-size: 65% 80%;
    background-position: 50% 50%;
    width: 80%;
    height: 100%;
    margin: 0.2rem auto;
    z-index: 0;
    /deep/ .amap-copyright {
      opacity: 0 !important;
    }
  }
}
</style>
